import axios from 'axios'

export default {
  namespaced: true,
  // state: {
  //     employee: null,
  //     employeeDocGrid: [],
  // },
  // mutations: {
  //     setEmployeeDocGrid(state, payload) {
  //         state.employeeDocGrid = payload ? payload : []
  //     },
  // },
  // getters: {
  //     employeeDoc: (state) => state.employeeDoc,
  //     employeeDocGrid: (state) => state.employeeDocGrid,
  // },
  actions: {
    onEmployeeWorkDay_dayReport_post({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/work-day/report',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeWorkDay_periodReport_post({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/work-day/period',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeWorkDay_periodReport_delete({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/work-day/period/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeWorkDay_extra_post({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/work-day/extra',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeWorkDay_extra_update({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/work-day/extra',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeWorkDay_extra_delete({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/work-day/extra/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
